// extracted by mini-css-extract-plugin
export default {"hideTooltip":"b9-z","fadeIn":"c9-z","delay":"d9-z","recommendedSizeTooltip":"e9-z"};